/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Records_FailedInputs */

const en_us2_exercise_sheet_records_failed = /** @type {(inputs: Exercise_Sheet_Records_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the records.`)
};

const pt_br2_exercise_sheet_records_failed = /** @type {(inputs: Exercise_Sheet_Records_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os recordes.`)
};

const es_419_exercise_sheet_records_failed = /** @type {(inputs: Exercise_Sheet_Records_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar los récords.`)
};

const pt_pt2_exercise_sheet_records_failed = /** @type {(inputs: Exercise_Sheet_Records_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar os recordes.`)
};

const fr_fr2_exercise_sheet_records_failed = /** @type {(inputs: Exercise_Sheet_Records_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les records.`)
};

const de_de2_exercise_sheet_records_failed = /** @type {(inputs: Exercise_Sheet_Records_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Rekorde konnten nicht geladen werden.`)
};

const it_it2_exercise_sheet_records_failed = /** @type {(inputs: Exercise_Sheet_Records_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare i record.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the records." |
*
* @param {Exercise_Sheet_Records_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_records_failed = /** @type {((inputs?: Exercise_Sheet_Records_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Records_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_records_failed(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_records_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_records_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_records_failed(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_records_failed(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_records_failed(inputs)
	return en_us2_exercise_sheet_records_failed(inputs)
});
export { exercise_sheet_records_failed as "exercise-sheet.records_failed" }